import CONSTANTS from '@/constants'

const { PRODUCT_TYPES } = CONSTANTS

export const vouchersHydratation = certificationVouchersCollection => {
  certificationVouchersCollection.forEach(voucher => {
    voucher.product_type = PRODUCT_TYPES.CERTIFICATE
    voucher.addOn = false
    voucher.addOnChecked = false
    voucher.included = false
    // "Included free" relation is data-driven from the API: the bundle plans
    // that include this voucher at no cost. Name/description/price come straight
    // from the API payload.
    voucher.includedWith =
      Array.isArray(voucher.included_with_plan_merchant_ids) &&
      voucher.included_with_plan_merchant_ids.length
        ? voucher.included_with_plan_merchant_ids
        : null
  })
}
